import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXsLogoColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 24,
	viewBox: "0 0 45 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3475 23.0161C34.1905 23.0161 33.0836 22.8727 32.0291 22.5859C30.9746 22.2991 30.0203 21.9077 29.1708 21.4093C28.319 20.9109 27.622 20.351 27.0777 19.7251C26.5334 19.0992 26.194 18.4279 26.0574 17.7064L31.4688 16.2771C31.7194 16.8916 32.1544 17.4265 32.7784 17.8816C33.4025 18.3368 34.1905 18.5758 35.1448 18.5963C36.074 18.6168 36.8529 18.4165 37.477 17.9932C38.101 17.5699 38.4131 17.0191 38.4131 16.3409C38.4131 15.8106 38.1921 15.344 37.7503 14.9412C37.3084 14.5384 36.6776 14.2311 35.8622 14.0195L32.4937 13.2252C31.3139 12.9498 30.2868 12.5151 29.4145 11.9211C28.5399 11.3294 27.8612 10.6011 27.3715 9.74308C26.8841 8.88507 26.6404 7.90416 26.6404 6.80263C26.6404 4.66329 27.4011 2.99507 28.9202 1.79568C30.4394 0.598558 32.5848 0 35.352 0C36.8712 0 38.199 0.195726 39.3332 0.587179C40.4674 0.978632 41.4376 1.55671 42.2439 2.31913C43.0479 3.08155 43.6901 4.03515 44.1661 5.17992L38.7889 6.6729C38.6066 6.10166 38.2149 5.58275 37.6136 5.1162C37.0124 4.64964 36.2357 4.4175 35.2814 4.4175C34.3271 4.4175 33.5847 4.62005 33.0517 5.02061C32.5188 5.42344 32.2523 6.00607 32.2523 6.76849C32.2523 7.29877 32.4687 7.73802 32.8991 8.0885C33.3296 8.43899 33.9195 8.69844 34.6688 8.86686L38.0373 9.66114C39.9663 10.1072 41.4695 10.9379 42.5468 12.1555C43.6241 13.3731 44.1639 14.7569 44.1639 16.3045C44.1639 17.7019 43.8177 18.9012 43.1253 19.8958C42.4329 20.8926 41.4285 21.6596 40.1144 22.199C38.798 22.7384 37.2105 23.0092 35.3498 23.0092L35.3475 23.0161Z",
			fill: "#0C0B5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3372 10.5874H10.684C8.90976 10.5874 7.23349 9.76584 6.14938 8.36162L0 0.409668H6.88047L14.3372 10.5852V10.5874Z",
			fill: "#833696"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.036 11.5114L25.6064 0.409668H18.6258L15.3096 5.26186C14.4806 6.47491 14.5079 8.07713 15.3802 9.2606L17.036 11.5092V11.5114Z",
			fill: "#0C0B5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3372 12.4336H10.684C8.90976 12.4336 7.23349 13.2552 6.14938 14.6594L0 22.6114H6.88047L14.3372 12.4359V12.4336Z",
			fill: "#0C0B5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.036 11.5117L25.6064 22.6112H18.6258L15.3096 17.759C14.4806 16.546 14.5079 14.9438 15.3802 13.7603L17.036 11.5117Z",
			fill: "#0C0B5A"
		})
	]
});
export default SvgXsLogoColor;
